import {
    Document,
    Font,
    Image,
    Page,
    StyleSheet,
    Text,
    View,
} from "@react-pdf/renderer";
import moment from "moment";
import "moment/locale/id";
import OpenSansBold from "../../assets/fonts/OpenSans-Bold.ttf";
import OpenSansMedium from "../../assets/fonts/OpenSans-Medium.ttf";
import OpenSans from "../../assets/fonts/OpenSans-Regular.ttf";
import OpenSansSemiBold from "../../assets/fonts/OpenSans-SemiBold.ttf";
import UbuntuMono from "../../assets/fonts/UbuntuMono-Regular.ttf";
import { DetailBundling } from "../../constants/types";

Font.register({
    family: "OpenSans",
    format: "truetype",
    src: OpenSans,
});
Font.register({
    family: "OpenSansBold",
    format: "truetype",
    src: OpenSansBold,
});
Font.register({
    family: "OpenSansSemiBold",
    format: "truetype",
    src: OpenSansSemiBold,
});
Font.register({
    family: "OpenSansMedium",
    format: "truetype",
    src: OpenSansMedium,
});
Font.register({
    family: "UbuntuMono",
    format: "truetype",
    src: UbuntuMono,
});

// const stylesheet = {
//     // clear margins for all <p> tags
//     p: {
//         margin: 0,
//         textAlign: "center",
//     },
// };

moment.locales();
moment.locale("id");

interface ICart {
    id: number;
    namaBarang: string;
    namaKategori: string;
    sku?: string | undefined;
    qty: number;
    harga: number;
    jumlahStok?: number | undefined;
    keteranganItem: string | null;
    detailBundling: DetailBundling[] | [];
}

interface IPrintStrukProps {
    is80mm: boolean;
    namaToko: string;
    gambarToko?: string;
    alamatToko: string;
    telpToko: string;
    kasir: string;
    tanggalTransaksi: string;
    transaksiKe: string;
    cart: ICart[] | undefined;
    isIncludeDapur?: boolean;
    keteranganBeli: string;
}

const PrintStrukPdf = (props: IPrintStrukProps) => {
    const isExtraBigSpacing =
        props.cart?.length === 1 && !props.cart[0].keteranganItem;
    const isBigSpacing =
        props.cart?.length === 1 && props.cart[0].keteranganItem;
    const isMediumSpacing =
        props.cart && props.cart?.length > 1 && props.cart?.length < 6;
    const isSmallSpacing =
        props.cart && props.cart?.length > 5 && props.cart?.length < 11;

    const styles = StyleSheet.create({
        page: {
            backgroundColor: "#FFF",
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 14,
            paddingRight: 14,
            height: "100%",
        },
        containerTitle: {
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            alignItems: "center",
            justifyContent: "center",
            marginVertical: 12,
        },
        title: {
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 10,
            marginTop: 0,
            marginLeft: "auto",
            marginRight: "auto",
            textAlign: "center",
            fontFamily: "OpenSansSemiBold",
            fontWeight: "bold",
        },
        subtitle: {
            fontSize: 8,
            marginTop: 0,
            marginLeft: "auto",
            marginRight: "auto",
            textAlign: "center",
            fontFamily: "OpenSans",
        },
        cashierName: {
            fontSize: 8,
            marginTop: 6,
            fontFamily: "OpenSans",
        },
        tanggalTransaksi: {
            flexDirection: "row",
            justifyContent: "space-between",
            fontSize: 8,
            fontFamily: "OpenSans",
        },
        containerHeader: {
            flexDirection: "row",
            backgroundColor: "#45A779",
            color: "#fff",
            alignItems: "center",
            height: 24,
            textAlign: "center",
            fontStyle: "bold",
            flexGrow: 1,
        },
        namaHeader: {
            width: "45%",
            fontSize: 14,
            fontWeight: 700,
        },
        hargaHeader: {
            width: "15%",
            fontSize: 14,
            fontWeight: 700,
        },
        jumlahHeader: {
            width: "10%",
            fontSize: 14,
            fontWeight: 700,
        },
        skuHeader: {
            width: "25%",
            fontSize: 14,
            fontWeight: 700,
        },
        row: {
            fontSize: 8,
            flexDirection: "row",
            fontFamily: "OpenSans",
        },
        column: {
            marginTop: 2,
            marginBottom: 4,
            fontSize: 8,
            flexDirection: "column",
            fontFamily: "OpenSans",
        },
        columnDapur: {
            marginTop: 2,
            marginBottom: 2,
            fontSize: 8,
            flexDirection: "column",
            fontFamily: "OpenSans",
        },
        columnKategori: {
            marginTop: 4,
            marginBottom: 4,
            marginLeft: 5,
            fontSize: 8,
            flexDirection: "column",
            fontFamily: "OpenSans",
        },
        containerNamaBarang: {
            width: "100%",
            flexDirection: "column",
        },
        namaBarang: {
            textAlign: "left",
            fontSize: 8,
            marginBottom: 1,
            fontFamily: "OpenSansSemiBold",
        },
        namaBundling: {
            textAlign: "left",
            fontSize: 8,
            marginBottom: 1,
        },
        qty: {
            width: "15%",
            textAlign: "left",
            fontSize: 8,
        },
        hargaSatuan: {
            width: "40%",
            fontSize: 8,
            textAlign: "left",
        },
        rate: {
            width: "45%",
            textAlign: "right",
            fontSize: 8,
        },
        keteranganBeli: {
            fontSize: 8,
            marginTop: 8,
            fontFamily: "OpenSans",
        },
        keteranganItem: {
            fontSize: 8,
            fontFamily: "OpenSans",
            lineHeight: 1.2,
        },
        divider: {
            marginVertical: 4,
            borderTop: "1px",
            color: "black",
            borderStyle: "dashed",
        },
        containerInfoTransaksi: {
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            fontFamily: "OpenSans",
        },
        infoTransaksi: {
            fontSize: 8,
            width: "50%",
            textAlign: "left",
        },
        nilaiTransaksi: {
            width: "50%",
            fontSize: 8,
            textAlign: "right",
        },
        infoTransaksiBold: {
            fontSize: 8,
            fontFamily: "OpenSansSemiBold",
            width: "40%",
            textAlign: "left",
        },
        nilaiTransaksiBold: {
            width: "50%",
            fontSize: 8,
            fontFamily: "OpenSansSemiBold",
            textAlign: "right",
        },
        containerPenutup: {
            marginTop: 14,
            display: "flex",
            flexDirection: "column",
            // justifyContent: "center",
            // alignItems: "center",
            fontSize: 8,
            fontFamily: "OpenSansSemiBold",
        },
        containerBelumLunas: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 8,
            fontFamily: "OpenSans",
        },
        penutup: {
            fontSize: 8,
            fontFamily: "OpenSansSemiBold",
        },
        containerWaterMark: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 6,
            marginTop: isExtraBigSpacing
                ? 500
                : isBigSpacing
                  ? 400
                  : isMediumSpacing
                    ? 300
                    : isSmallSpacing
                      ? 260
                      : 5,
            // marginTop: 30,
            marginBottom: 5,
            fontFamily: "Helvetica",
        },
        containerNore: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 6,
        },
        containerLogo: {
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: 12,
            marginBottom: 6,
        },
        logo: {
            width: 54,
            height: 54,
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            alignItems: "center",
            justifyContent: "center",
        },
        qr: {
            width: "3cm",
            height: "3cm",
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            alignItems: "center",
            justifyContent: "center",
        },
        boldText: {
            fontWeight: 700,
            fontFamily: "OpenSansSemiBold",
        },
        containerJatuhTempo: {
            width: "100%",
            marginTop: 10,
            marginBottom: 14,
        },
        namaKategori: {
            textAlign: "left",
            fontSize: 8,
            marginBottom: 1,
            fontWeight: 700,
            fontFamily: "OpenSansBold",
        },
    });

    const widthInCm = 7;
    const widthInPoints = widthInCm * 28.35;

    const rowDapur =
        props.cart &&
        props.cart.map((row) => (
            <View style={styles.columnDapur} key={row.id}>
                <View style={{ flexDirection: "row" }}>
                    <Text style={styles.qty}>{row.qty}x</Text>
                    <Text>{row.namaBarang}</Text>
                </View>
                {row.detailBundling?.length > 0 && (
                    <View style={{ width: "100%", flexDirection: "column" }}>
                        <Text
                            style={[
                                styles.keteranganItem,
                                {
                                    flexWrap: "wrap",
                                    display: "flex",
                                    flexGrow: 1,
                                    flexBasis: 0,
                                },
                            ]}
                        >
                            {row.detailBundling
                                ?.map(
                                    (item) =>
                                        `${item.namaBarang || item.nama} (${item.jumlahYangDiambil || item.totalDiambil})`,
                                )
                                .join(", ")}
                        </Text>
                    </View>
                )}

                <View style={{ width: "100%", flexDirection: "column" }}>
                    <Text
                        style={[
                            styles.keteranganItem,
                            {
                                flexWrap: "wrap",
                                display: "flex",
                                flexGrow: 1,
                                flexBasis: 0,
                            },
                        ]}
                    >
                        Ket:{" "}
                        {row.keteranganItem &&
                        row.keteranganItem !== "null" &&
                        row.keteranganItem.trim() !== ""
                            ? row.keteranganItem
                            : "-"}
                    </Text>
                </View>
            </View>
        ));

    const isFormattedDate = (dateStr: moment.MomentInput) => {
        return moment(dateStr, "DD MMM YYYY HH:mm", true).isValid();
    };

    return (
        <Document>
            {props.isIncludeDapur ? (
                <Page
                    wrap
                    size={{
                        width: props.is80mm ? widthInPoints : "5.5cm",
                        height: "100%",
                    }}
                    style={styles.page}
                >
                    <View>
                        {props.gambarToko ? (
                            <View style={styles.containerLogo}>
                                <Image
                                    style={styles.logo}
                                    src={props.gambarToko}
                                />
                            </View>
                        ) : (
                            <View></View>
                        )}
                        <View style={styles.containerTitle}>
                            <View style={styles.title}>
                                <Text>{props.namaToko}</Text>
                            </View>
                            <View style={styles.subtitle}>
                                <Text>{props.alamatToko}</Text>
                            </View>
                            <View style={styles.subtitle}>
                                <Text>+{props.telpToko}</Text>
                            </View>
                        </View>

                        {props.transaksiKe !== null && (
                            <View style={styles.tanggalTransaksi}>
                                <Text>No. Transaksi</Text>
                                <Text>{props.transaksiKe}</Text>
                            </View>
                        )}

                        <View style={styles.tanggalTransaksi}>
                            <Text>Kasir</Text>
                            <Text>{props.kasir}</Text>
                        </View>

                        <View style={styles.tanggalTransaksi}>
                            <Text>Tanggal</Text>
                            <Text>
                                {isFormattedDate(props.tanggalTransaksi)
                                    ? props.tanggalTransaksi
                                    : moment(props.tanggalTransaksi).format(
                                          "DD MMM YYYY HH:mm",
                                      )}
                            </Text>
                        </View>

                        <View style={styles.divider}></View>

                        <View>{rowDapur}</View>

                        <View style={styles.divider}></View>

                        {props.keteranganBeli ? (
                            <View style={styles.keteranganBeli}>
                                <Text>Keterangan:</Text>
                                <Text>{props.keteranganBeli}</Text>
                            </View>
                        ) : (
                            <View></View>
                        )}

                        <View style={styles.containerWaterMark}></View>
                    </View>
                </Page>
            ) : null}
        </Document>
    );
};

export default PrintStrukPdf;
